const webUrl = document.location.origin;

export const baseUrl = {
  pass: process.env.REACT_APP_API_PASS_URL,
  business: process.env.REACT_APP_API_BUSINESS_URL,
  product: process.env.REACT_APP_API_PRODUCT_URL,
  order: process.env.REACT_APP_API_ORDER_URL,
  bucket: process.env.REACT_APP_API_BUCKET_URL,
  productAdmin: process.env.REACT_APP_API_PRODUCT_ADMIN_URL,
  social: process.env.REACT_APP_API_SOCIAL_URL,
  webUrl: webUrl,
};
